<template>
    <v-container fluid fill-height class="flex-column justify-center">
        <v-card 
            color="white"
            class="mx-auto custom-radius"
            width="100%"
            max-width="550"
            elevation="3"
        >
            <v-card-text class="pa-lg-8">
                <img src="@/assets/images/claass-logo-original-without-betta.svg" class="class-logo" />
                <v-alert type="error" color="secondary" class="mt-8">
                    {{ $t('RejectedMentorProfileNotification') }}
                </v-alert>
            </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
    export default {
        name: 'rejectedAccount',
        created() {
            this.$store.dispatch('logout')
        }
    }
</script>

<style lang="scss" scoped>
.container--fluid{
    background-image: url('~@/assets/images/landing-page.png');
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
    .class-logo{
        display: block;
        max-width: 100%;
        height: 135px;
        margin: 0 auto;
    }
}
</style>